export default __webpack_public_path__ + "static/media/saved.b9f68c8f.svg";